module.exports = __webpack_public_path__ + "img/icon-home-active.a143fc64.svg";